import { ClientError } from 'graphql-request'

// Code the backend attaches when the brand account has AI turned off.
// The 9segs-analyzer and 9segs-overall subgraphs both return this value.
const AI_DISABLED_ERROR_CODE = 'AI_DISABLED'

/**
 * Reports whether a caught value is a rejection caused by AI being turned off.
 *
 * graphql-request throws GraphQL errors as ClientError, whose message has the
 * whole response JSON concatenated onto it, so it can never be shown as-is.
 * Callers use this check to swap in a user-facing instruction instead.
 *
 * @param error - Value caught from a rejected request.
 * @returns True when the rejection was caused by AI being off.
 */
export function isAiDisabledError(error: unknown): boolean {
  if (!(error instanceof ClientError)) {
    return false
  }

  // Federation can surface several errors at once, so do not look at only the first.
  return (error.response.errors ?? []).some(
    (e) => e.extensions?.code === AI_DISABLED_ERROR_CODE,
  )
}
